// Почему к брони добавлены сутки за остаток часов (FT-084 DEC-01).
//
// Причину сообщает движок в ответе квоты (`units.extra_day_reason`) — на клиенте её
// НЕ пересчитываем: цена дня-носителя зависит от сезона и тарифной ступени, а прежняя
// клиентская пере-реализация ещё и сравнивала `>` там, где движок сравнивает `>=`.
//
// Зачем подсказка: пользователь видит настройку «сутки после N доп. часов» и не понимает,
// почему сутки добавились на меньшем остатке — ценовое правило «допчасы дороже суток»
// действует НЕЗАВИСИМО от этой настройки (staging 2026-07-31).
const REASON_KEYS = {
  hours_limit: "bookings.extra_day_reason_hours_limit",
  hours_costlier_than_day: "bookings.extra_day_reason_hours_costlier",
};

// Ответ квоты → i18n-ключ подсказки ("" если сутки за остаток не добавлялись).
// Ответ без поля (старый бэкенд, внешняя интеграция, кэш) и неизвестная причина из
// будущей версии — тихо без подсказки, экран ломаться не должен.
//
// hasOwnProperty, а не REASON_KEYS[reason]: строка приходит из сети, и ключи прототипа
// ("constructor", "toString") вернули бы truthy-функцию, которая уехала бы в $t().
export function extraDayReasonKey(quoteResponse) {
  const reason = quoteResponse && quoteResponse.units && quoteResponse.units.extra_day_reason;
  if (typeof reason !== "string") return "";
  return Object.prototype.hasOwnProperty.call(REASON_KEYS, reason) ? REASON_KEYS[reason] : "";
}

export { REASON_KEYS };
